export default __webpack_public_path__ + "static/media/paidInternationalTrips.cbd55985.svg";